module.exports = __webpack_public_path__ + "img/stellini_logo.b29d47b9.png";